import { render, staticRenderFns } from "./CardapioGrupos.vue?vue&type=template&id=fbb89f4c&scoped=true"
import script from "./CardapioGrupos.vue?vue&type=script&lang=js"
export * from "./CardapioGrupos.vue?vue&type=script&lang=js"
import style0 from "./CardapioGrupos.vue?vue&type=style&index=0&id=fbb89f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb89f4c",
  null
  
)

export default component.exports